import React from 'react'
import Search from './components/Search'
import { useState, useEffect } from 'react'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import Menu from './components/Menu'

function App() {

  const [eateries, setEateries] = useState([])

  //Get data from API
  const getData = async (name) => {
    var searchTerm = JSON.stringify(name)

    // console.log(name);
    // console.log(searchTerm);

    const response = await fetch('https://yelp-backend.netlify.app/.netlify/functions/search?location=boston&term=' + searchTerm);
    const data = await response.json();
    setEateries(data.businesses)
  }

  useEffect(() => {
    getData();
  }, [])

  return (
    <Router>
      <div className='container'>

        <header>
          <h1>Welp</h1>
          <p>Search for restaurants in Boston</p>
        </header>

        <Routes>
          <Route path='/' element= {
            <>
              <Search eateries={eateries} getData={getData}/>
            </>
          }
          />
          <Route path='/Menu/:id' element={<Menu eateries={eateries}/>} /> 
        </Routes>

      </div>      
    </Router>

  );
}

export default App;
